import { timestamp, Timestamp } from "@/api/firebase/firebase.config";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import { Box, Flex, Select, Text, TextArea } from "@radix-ui/themes";
import i18next from "i18next";
import { FC, useEffect } from "react";

interface FeedbackFormInputProps {
  feedback: {
    userName: string;
    uid: string;
    type: string;
    details: string;
    userAgent: string;
    createdAt: Timestamp;
  };
  setFeedback: (feedback: {
    userName: string;
    uid: string;
    type: string;
    details: string;
    userAgent: string;
    createdAt: Timestamp;
  }) => void;
}

const FeedbackFormInput: FC<FeedbackFormInputProps> = ({
  feedback,
  setFeedback,
}): JSX.Element => {
  const currentUser = useCurrentUserProfile((s) => s.user);

  const deviceInfo = {
    userAgent: navigator.userAgent,
  };

  useEffect(() => {
    setFeedback({
      ...feedback,
      userAgent: deviceInfo.userAgent,
      createdAt: timestamp.now(),
    });
  }, [deviceInfo]);

  useEffect(() => {
    setFeedback({
      ...feedback,
      userName: currentUser.userName,
      uid: currentUser.uid,
    });
  }, [currentUser]);

  return (
    <Box>
      <Flex direction="column" gap="4">
        {/* Type of feedback */}
        <Flex direction="column" gap="1">
          <Text as="label" size="2">
            {i18next.t("feedback.fields.type.label")}
          </Text>
          <Select.Root
            defaultValue="bug"
            size="3"
            value={feedback.type}
            onValueChange={(e) => {
              setFeedback({ ...feedback, type: e });
            }}
          >
            <Select.Trigger />
            <Select.Content>
              <Select.Group>
                <Select.Label>Feedback type</Select.Label>
                <Select.Item value="bug">
                  🐞 {i18next.t("feedback.fields.type.bug")}
                </Select.Item>
                <Select.Item value="feature">
                  💡 {i18next.t("feedback.fields.type.feature")}
                </Select.Item>
                <Select.Item value="general">
                  📣 {i18next.t("feedback.fields.type.general")}
                </Select.Item>
                <Select.Item value="other">
                  ❓ {i18next.t("feedback.fields.type.other")}
                </Select.Item>
              </Select.Group>
            </Select.Content>
          </Select.Root>
        </Flex>

        {/* Message */}
        <Flex direction="column" gap="1">
          <Text as="label" size="2">
            {i18next.t("feedback.fields.details.label")}
          </Text>
          <TextArea
            placeholder={i18next.t("feedback.fields.details.placeholder")}
            size="3"
            value={feedback.details}
            onChange={(e) => {
              setFeedback({ ...feedback, details: e.target.value });
            }}
          />
        </Flex>
      </Flex>
    </Box>
  );
};

export default FeedbackFormInput;
